// Imports
import Vue from 'vue'
import Router from 'vue-router'
import { trailingSlash } from '../util/helpers'
import {
  layout,
  route,
} from '../util/routes'
import i18n from '../i18n'
import store from '../store'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    layout('Default', [
      route('Dashboard'),

      // Pages
      route('VM', null, 'server/vm'),
      route('BBB', null, 'server/bbb'),
      route('BBBStyles', null, 'server/styles'),
      route('LB', null, 'server/lb'),
      route('Meetings', null, 'server/meetings'),
      route('LB_BBB', null, 'server/lb/:lbId'),
      route('LB_BBB_V2', null, 'server/lb-v2/:lbId'),
      route('Commands', null, 'server/commands'),
      route('LMSDashboardList', null, 'lms/dashboard'),
      route('LMSDashboard', null, 'lms/dashboard/:uuid'),
      route('LMSConfig', null, 'lms/config'),
      // route('UpdateLMS', null, 'lms/update'),
      route('Category', null, 'lms/category'),
      route('Course', null, 'lms/course'),
      route('Student', null, 'lms/student'),
      route('Professor', null, 'lms/professor'),
      route('Enrollment', null, 'lms/enrollment'),
      route('LMSBigbluebutton', null, 'lms/bigbluebutton'),
      route('LmsLogs', null, 'lms/logs'),
      route('WebinarPlus', null, 'webinarplus/list'),
      route('WebinarPlusConfig', null, 'webinarplus/config'),
      route('WebinarPlusUsers', null, 'webinarplus/users'),
      route('WebinarPlusPlans', null, 'webinarplus/plans'),
      route('WebinarPlusUsersLogs', null, 'webinarplus/logs'),
      route('WebinarPlusUsersBalanceLogs', null, 'webinarplus/balancelogs'),
      route('WebinarPlusInvoices', null, 'webinarplus/invoices'),
      route('WebinarPlusHooks', null, 'webinarplus/hooks'),
      route('WebinarPlusSettings', null, 'webinarplus/settings'),
      route('WebinarPlusSettingsGateways', null, 'webinarplus/settings/:settingId/gateway'),
      route('WebinarPlusSmsPatterns', null, '/webinarplus/sms/patterns'),
      route('Users', null, 'users'),
      route('UserPermissions', null, 'users/permissions/:userId'),
      route('SMSPanels', null, 'sms/panels'),
      route('SMSTokens', null, 'sms/tokens'),
      route('SMSLogs', null, 'sms/logs'),
    ]),
    layout('Login', [
      route('Login', null, 'login'),
    ]),
    layout('Frame', [
      route('LearningDashboard', null, 'learningDashboard'),
    ])
  ],
})

router.beforeEach((to, from, next) => {
  if (to.path === 'learningDashboard')
     return next();
  else if (to.path != '/login' && !store.state.login.isLogin && to.path != '/learningDashboard') {
    console.log("1",to.path,store.state.login.isLogin,from)
    store.state.login.isLogin=false;
    localStorage.removeItem('isLogin');
    return next({ path: 'login', replace: true });
  }
  else if (to.path !='/login' && from.name===null && !store.state.login.isLogin){
    console.log("2",to.path,store.state.login.isLogin,from)
    store.state.login.isLogin=false;
    localStorage.removeItem('isLogin');
    return next({ path: 'login', replace: true });
  }
  else if (to.path === '/login' && store.state.login.isLogin) {
    console.log("3",to.path,store.state.login.isLogin,from)
    return next({ path: '/', replace: true });
  }
  else {
    return next()
  }
  // to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
})

export default router
